// extracted by mini-css-extract-plugin
export default {"ai_bot_avatar":"styles_ai_bot_avatar__qExvy"};